import React, { useEffect, useState } from "react";
import style from "./generative-search.module.css";
import {
  generateIdeas,
  processAndDisplayIdeas,
} from "./generative-search-util-functions";
import {
  exampleInputs,
  informationalWords,
  fictionalWords,
  unexpectedWords,
} from "../../constants/constants";

const thumbnailUrl = "https://i.imgur.com/BkhIj2f.jpeg";

export const GenerativeSearch = () => {
  const [searchInput, setSearchInput] = useState("");
  const [ideas, setIdeas] = useState([
    { ready: false },
    { ready: false },
    { ready: false },
    { ready: false },
    { ready: false },
    { ready: false },
  ]);
  const [initialSuggestions, setInitialSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showCards, setShowCards] = useState(false);

  const [fadeInIndices, setFadeInIndices] = useState([]);

  useEffect(() => {
    const initialSuggestions = getRandomInitialSuggestions();
    setInitialSuggestions(initialSuggestions);
    initialSuggestions.forEach((_, index) => {
      setTimeout(() => {
        setFadeInIndices((prev) => [...prev, index]);
      }, 100 * index);
    });
  }, []);

  function handleSearchInputChange(e) {
    setSearchInput(e.target.value);
  }

  function getRandomInitialSuggestions() {
    const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];
    return [
      getRandomItem(informationalWords),
      getRandomItem(fictionalWords),
      getRandomItem(unexpectedWords),
      getRandomItem([...informationalWords, ...fictionalWords]),
      getRandomItem([...fictionalWords, ...unexpectedWords]),
    ];
  }

  async function handleGenerateClick() {
    if (searchInput.trim() !== "" && !isLoading) {
      setIsLoading(true);
      setShowCards(true);

      //   try {
      //     const generatedIdeas = await generateIdeas(searchInput);
      //     const processedIdeas = await processAndDisplayIdeas(generatedIdeas);
      //     setIdeas(processedIdeas);

      //     console.log("Ideas generated:", generatedIdeas);
      //     console.log("Processed ideas:", processedIdeas);
      //   } catch (error) {
      //     console.error("Error generating ideas:", error);
      //     // Handle error (e.g., show an error message to the user)
      //     // toast.error("Failed to generate ideas. Please try again.");
      //   } finally {
      //     setIsLoading(false);
      //   }
    }
  }

  return (
    <div className={style["generative-search"]}>
      <div className={style["content-wrapper"]}>
        <div className={style["search-container"]}>
          <input
            // ref={inputRef}
            // type="text"
            value={searchInput}
            onChange={handleSearchInputChange}
            // onKeyPress={handleKeyPress}
            placeholder="Enter anything you want"
            maxLength={100}
            className={style["search-input"]}
          />
          <button
            onClick={handleGenerateClick}
            className={`${style["generate-button"]} ${isLoading ? style["generating"] : ""}`}
            disabled={isLoading || searchInput.trim() === ""}
          >
            Explore
          </button>
          {/* add settings menu */}
        </div>
        {!showCards && (
          <div className={style["recommendations-bar"]}>
            <div className={style["suggestions-row"]}>
              {initialSuggestions.slice(0, 3).map((suggestion, index) => (
                <button
                  key={index}
                  onClick={() => setSearchInput(suggestion)}
                  className={`${style["initial-suggestion"]} ${fadeInIndices.includes(index) ? style["fade-in-suggestion"] : ""}`}
                >
                  <img
                    src={thumbnailUrl}
                    alt="thumbnail"
                    style={{
                      width: "38px",
                      height: "38px",
                      marginRight: "8px",
                    }}
                  />
                  {suggestion}
                </button>
              ))}
            </div>
            <div className={style["suggestions-row"]}>
              {initialSuggestions.slice(3).map((suggestion, index) => (
                <button
                  key={index + 3}
                  onClick={() => setSearchInput(suggestion)}
                  className={`${style["initial-suggestion"]} ${fadeInIndices.includes(index + 3) ? style["fade-in-suggestion"] : ""}`}
                >
                  <img
                    src={thumbnailUrl}
                    alt="thumbnail"
                    style={{
                      width: "38px",
                      height: "38px",
                      marginRight: "8px",
                    }}
                  />
                  {suggestion}
                </button>
              ))}
            </div>
          </div>
        )}
        {showCards && (
          <div
            className={`${style["cards-background-container"]} ${style["fade-in"]}`}
          >
            <div className={style["ideas-container"]}>
              {ideas.map((idea, index) => {
                return (
                  <div key={index} className={style["card-wrapper"]}>
                    {!idea.ready && (
                      <div className={style["loading-card"]}>
                        <div className={style["loading-animation"]}>
                          {/* Your loading animation JSX here */}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
